import { getApp, getApps, initializeApp, type FirebaseApp } from 'firebase/app';

// Web config from the Firebase console (project `nsave1`). The web API key is
// NOT a secret — it ships to the browser and is safe to commit.
export const firebaseConfig = {
  apiKey: 'AIzaSyDNS5sn6s5xZgpMyMZhIgpvlXmtmXuLSNI',
  authDomain: 'nsave1.firebaseapp.com',
  projectId: 'nsave1',
  storageBucket: 'nsave1.firebasestorage.app',
  messagingSenderId: '525056154097',
  appId: '1:525056154097:web:533ee30674c98192e14c50',
  measurementId: 'G-9EL023FNRQ',
};

/**
 * Returns the singleton Firebase app, initializing it on first use.
 * Use this anywhere you need a Firebase product, e.g.:
 *   import { getFirestore } from 'firebase/firestore'
 *   const db = getFirestore(getFirebaseApp())
 * `initializeApp` is inert (no data collection) until a product SDK is used,
 * and is safe to call on both server and client.
 */
export function getFirebaseApp(): FirebaseApp {
  return getApps().length ? getApp() : initializeApp(firebaseConfig);
}

/**
 * Initializes Firebase Analytics (GA4). Client-only and guarded by
 * `isSupported()`. Called from the consent-gated loader in `~/components/analytics`
 * — Analytics collects data, so it must not run before consent.
 */
export async function initFirebaseAnalytics() {
  if (typeof window === 'undefined') return;
  const { getAnalytics, isSupported } = await import('firebase/analytics');
  if (await isSupported()) {
    getAnalytics(getFirebaseApp());
  }
}
